export default __webpack_public_path__ + "static/media/tick_check.936286b8.svg";